/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('./chat');
require('./speech_to_text');
require('./overflowing');
require('jquery-ui-dist/jquery-ui');
require('./main');
require('./save');
require('./delete');
require('./search');
require('./table_relation');
require('./settings');
require('./audit-trail');
require('./templates');
require('./exports');
require('./formula');
require('./crud_records');
require('./users');
require('./browse');
require('./filters');
require('./bulk_create');
require('./calendar');
require('./online_calendar');
require('./kanban');
require('./bootstrap-colorpicker.js');
require('./fontawesome-iconpicker.min.js');
require('./reports');
require('./charts');
require('./dashboard_chart_filters');
require('./buttons');
require('./alerts');
require('./editable');
require('./notifications');
require('./sync');
require('./help');
require('./images');
require('./integrations');
require('./xml_builder');
require('./webform');
require('./attachments');
require('./mobile');
require('./barcode');
require('./menu');
require('./imports');
require('./autonumber');
require('./bootstrap-colorpicker.js'); //bootstrap-colorpicker
require('./fontawesome-iconpicker.min.js'); //fontawesome-iconpicker1
let flatpickr = require('flatpickr');
flatpickr.l10ns.default.firstDayOfWeek = 1;
import 'bootstrap-select';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css'
import vco from "v-click-outside";
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import VueI18n from 'vue-i18n'
import Inbox from "./components/emails/Inbox";
import WebMail from "./components/emails/WebMail";
import VueRouter from 'vue-router';
import {Plugin} from 'vue-fragment';
import {processSectionFormulas} from "./formula_functions";
import tinymce from "tinymce";
import bootbox from 'bootbox';

window.Vue = require('vue');
Vue.use(BootstrapVue);
Vue.use(vco);
Vue.use(VueI18n);

let i18nOptions = require('./i18n.js');
const i18n = new VueI18n(i18nOptions);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

//Vue.component('example-component', require('./components/ExampleComponent.vue').default);

Vue.component('emails', require('./components/emails/Emails.vue').default);
Vue.component('add-emails', require('./components/emails/AddEmails.vue').default);
Vue.component('email-list', require('./components/emails/EmailList.vue').default);
Vue.component('composer-email', require('./components/emails/Compose.vue').default);
Vue.component('compose-button', require('./components/emails/ComposeButton.vue').default);
Vue.component('compose-webmail', require('./components/emails/ComposeWebmail.vue').default);
Vue.component('edit-email', require('./components/emails/EditEmail.vue').default);

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);

if (document.getElementById('smtp-emails')) {
    console.log($('#smtp-emails').length);
    new Vue({
        el: '#smtp-emails',
        i18n
    });
}


Vue.use(Plugin);

if (document.getElementById('webmail')) {

    Vue.use(VueRouter);

    const routes = [
        {
            path: "/",
            redirect: '/0/inbox',
            name: 'index'
        },
        {
            path: "/0/:type",
            component: Inbox,
            name: 'inbox'
        },
        {
            path: "/0/:type/:thread",
            component: Inbox,
            name: 'inbox_thread'
        },
        {
            path: "/compose",
            name: "compose",
            component: WebMail,
        },
    ];

    const router = new VueRouter({
        routes // short for `routes: routes`
    });

    new Vue({
        router,
        i18n
    }).$mount('#webmail')
}


if (document.getElementById('compose-button')) {
    new Vue({
        el: '#compose-button',
        i18n
    });
}


if (document.getElementById('mail-component')) {
    new Vue({
        el: '#mail-component',
        i18n
    });
}

if (document.getElementById('activity-log-body')) {
    new Vue({
        el: '#activity-log-body',
        i18n
    });
}

if (document.getElementById('automated-section')) {
    const automated = new Vue({
        el: '#automated-section',
        data: {
            conditions: [
                {having: 'is', dropdown_value: 'is'},
                {having: 'is not', dropdown_value: 'is_not'},
                {having: 'starts with', dropdown_value: 'starts_with'},
                {having: 'ends with', dropdown_value: 'ends_with'}
            ],
            conditions_for_number: [
                {having: 'is', dropdown_value: 'is'},
                {having: 'is not', dropdown_value: 'is_not'},
                {having: 'greater than', dropdown_value: 'greater_than'},
                {having: 'greater than or equals to', dropdown_value: 'greater_than_or_equals_to'}
            ],
            tables: null,
        },
        mounted: function () {

        },
        methods: {
            selectedCondition(get_condition) {
                console.log(get_condition);
            }
        }
    });
}
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// const app = new Vue({
//     el: '#app'
// });
$(document).ready(function ($) {

    $.fn.selectpicker.Constructor.BootstrapVersion = '4.3.1';

    $('.selectpicker').selectpicker({
        container: 'body',
        noneSelectedText: translation.nothing_selected
    })
        .selectpicker('setStyle', 'btn-light', 'remove')
        .selectpicker('setStyle', 'btn-block', 'add');

    $(document).on('change', '.selectpicker', function (e) {
        if ($(this).data('selectpicker') !== undefined) {
            $(this).data('selectpicker').$button.blur();
        }
    });

    $('.user-company-picker').selectpicker({
        container: 'body',
        noneSelectedText: translation.nothing_selected
    })
        .selectpicker('setStyle', 'btn-light', 'remove')
        .selectpicker('setStyle', 'btn-block', 'add')
        .siblings('.dropdown-menu')
        .addClass('user-company-dropdown');


    let date_format = $('meta[name="date-format"]').attr('content');

    $(".datepicker-cl").flatpickr({
        weekNumbers: true,
        dateFormat: date_format,
        closeOnSelect: true,
        allowInput: true,
        onChange: function (selectedDates, dateStr, instance) {
            $(instance.element).val(dateStr);
        },
        onReady: function (dateObj, dateStr, instance) {
            var $cal = $(instance.calendarContainer);
            if ($cal.find('.flatpickr-clear').length < 1) {
                $cal.append('<div class="flatpickr-clear">Clear</div>');
                $cal.find('.flatpickr-clear').on('click', function () {
                    instance.clear();
                    instance.close();
                    $(instance.element).trigger('keyup');
                });
            }
        }
    });

    $(".datetimepicker-cl").flatpickr({
        weekNumbers: true,
        dateFormat: date_format + " H:i",
        enableTime: true,
        time_24hr: true,
        closeOnSelect: false,
        allowInput: true,
        onChange: function (selectedDates, dateStr, instance) {
            $(instance.element).attr('value', dateStr).trigger('keyup');
        },
        onReady: function (dateObj, dateStr, instance) {
            let $cal = $(instance.calendarContainer);
            if ($cal.find('.flatpickr-clear').length < 1) {
                $cal.append('<div class="flatpickr-clear">Clear</div>');
                $cal.find('.flatpickr-clear').on('click', function () {
                    instance.clear();
                    instance.close();
                    $(instance.element).trigger('keyup');
                });
            }
        }
    });

    $(".timepicker-cl").flatpickr({
        weekNumbers: true,
        enableTime: true,
        noCalendar: true,
        time_24hr: true,
        dateFormat: "H:i",
        closeOnSelect: false,
        allowInput: true,
        onChange: function (selectedDates, dateStr, instance) {
            $(instance.element).attr('value', dateStr);
        },
        onReady: function (dateObj, dateStr, instance) {
            let $cal = $(instance.calendarContainer);
            if ($cal.find('.flatpickr-clear').length < 1) {
                $cal.append('<div class="flatpickr-clear">Clear</div>');
                $cal.find('.flatpickr-clear').on('click', function () {
                    instance.clear();
                    instance.close();
                    $(instance.element).trigger('keyup');
                });
            }
        }
    });

    $(".timeonlypicker-cl").flatpickr({
        weekNumbers: true,
        noCalendar: true,
        enableTime: true,
        dateFormat: 'H:i',
        time_24hr: true,
        closeOnSelect: false,
        allowInput: true,
        onChange: function (selectedDates, dateStr, instance) {
            $(instance.element).attr('value', dateStr).trigger('keyup');
        },
        onReady: function (dateObj, dateStr, instance) {
            let $cal = $(instance.calendarContainer);
            if ($cal.find('.flatpickr-clear').length < 1) {
                $cal.append('<div class="flatpickr-clear">Clear</div>');
                $cal.find('.flatpickr-clear').on('click', function () {
                    instance.clear();
                    instance.close();
                    $(instance.element).trigger('keyup');
                });
            }
        }
    });

    function initTinyMCE() {
        let tinyMCE_HTML = {
            language: $('meta[name="language"]').attr('content'),
            fontsize_formats: "6pt 8pt 9pt 10pt 11pt 12pt 13pt 14pt 15pt 16pt 18pt 20pt 22pt 24pt 26pt 30pt 34pt",
            selector: '.create-edit-editor',
            branding: false,
            menubar: 'edit insert view format table tools help',
            plugins: [
                "advlist autolink lists link image charmap print preview anchor",
                "searchreplace visualblocks code fullscreen",
                "insertdatetime media table paste",
                "image imagetools"
            ],
            image_list: "/template/images/logos",
            paste_data_images: true,
            urlconverter_callback: function (url, node, on_save, name) {
                return url;
            },
            images_upload_url: '/template/images/upload',
            images_upload_handler: function (blobInfo, success, failure) {
                let xhr, formData;

                xhr = new XMLHttpRequest();
                xhr.withCredentials = false;
                xhr.open('POST', '/template/images/upload');

                xhr.onload = function () {
                    let json;
                    if (xhr.status != 200) {
                        failure('HTTP Error: ' + xhr.status);
                        return;
                    }
                    json = JSON.parse(xhr.responseText);
                    if (!json || typeof json.location != 'string') {
                        failure('Invalid JSON: ' + xhr.responseText);
                        return;
                    }
                    success(json.location);
                };

                formData = new FormData();
                formData.append('file', blobInfo.blob(), blobInfo.filename());
                formData.append('_token', $(`meta[name="csrf-token"]`).attr('content'));
                xhr.send(formData);
            },
        };
        tinymce.remove();
        tinymce.init(tinyMCE_HTML);
    }

    function initCreateEditFormFields($container) {
        let date_format = $('meta[name="date-format"]').attr('content');

        $container.find(".datepicker-cl").flatpickr({
            weekNumbers: true,
            dateFormat: date_format,
            closeOnSelect: true,
            allowInput: true,
            onChange: function (selectedDates, dateStr, instance) {
                $(instance.element).attr('value', dateStr).trigger('keyup');
            },
            onReady: function (dateObj, dateStr, instance) {
                let $cal = $(instance.calendarContainer);
                if ($cal.find('.flatpickr-clear').length < 1) {
                    $cal.append('<div class="flatpickr-clear">Clear</div>');
                    $cal.find('.flatpickr-clear').on('click', function () {
                        instance.clear();
                        instance.close();
                        $(instance.element).trigger('keyup');
                    });
                }
            }
        });

        $container.find(".datetimepicker-cl").flatpickr({
            weekNumbers: true,
            dateFormat: date_format + " H:i",
            enableTime: true,
            time_24hr: true,
            closeOnSelect: false,
            allowInput: true,
            onChange: function (selectedDates, dateStr, instance) {
                $(instance.element).attr('value', dateStr).trigger('keyup');
            },
            onReady: function (dateObj, dateStr, instance) {
                let $cal = $(instance.calendarContainer);
                if ($cal.find('.flatpickr-clear').length < 1) {
                    $cal.append('<div class="flatpickr-clear">Clear</div>');
                    $cal.find('.flatpickr-clear').on('click', function () {
                        instance.clear();
                        instance.close();
                        $(instance.element).trigger('keyup');
                    });
                }
            }
        });

        $container.find(".timepicker-cl").flatpickr({
            weekNumbers: true,
            enableTime: true,
            noCalendar: true,
            time_24hr: true,
            dateFormat: "H:i",
            closeOnSelect: false,
            allowInput: true,
            onChange: function (selectedDates, dateStr, instance) {
                $(instance.element).attr('value', dateStr);
            },
            onReady: function (dateObj, dateStr, instance) {
                let $cal = $(instance.calendarContainer);
                if ($cal.find('.flatpickr-clear').length < 1) {
                    $cal.append('<div class="flatpickr-clear">Clear</div>');
                    $cal.find('.flatpickr-clear').on('click', function () {
                        instance.clear();
                        instance.close();
                        $(instance.element).trigger('keyup');
                    });
                }
            }
        });

        $container.find(".timeonlypicker-cl").flatpickr({
            weekNumbers: true,
            noCalendar: true,
            enableTime: true,
            dateFormat: 'H:i',
            time_24hr: true,
            closeOnSelect: false,
            allowInput: true,
            onChange: function (selectedDates, dateStr, instance) {
                $(instance.element).attr('value', dateStr).trigger('keyup');
            },
            onReady: function (dateObj, dateStr, instance) {
                let $cal = $(instance.calendarContainer);
                if ($cal.find('.flatpickr-clear').length < 1) {
                    $cal.append('<div class="flatpickr-clear">Clear</div>');
                    $cal.find('.flatpickr-clear').on('click', function () {
                        instance.clear();
                        instance.close();
                        $(instance.element).trigger('keyup');
                    });
                }
            }
        });

        $container.find('.selectpicker').selectpicker({
            container: 'body',
            noneSelectedText: translation.nothing_selected
        })
            .selectpicker('setStyle', 'btn-light', 'remove')
            .selectpicker('setStyle', 'btn-block', 'add');
    }

    window.initCreateEditFormFields = initCreateEditFormFields;
    window.processSectionFormulas = processSectionFormulas;
    window.initTinyMce = initTinyMCE;

    $(document).on('keyup', '.form-control[data-capital="1"]', function (event) {
        event.target.value = event.target.value.toLocaleUpperCase()
    })

    $('#sidebar').on('mouseenter', function (e) {
        $('.related-tabs').addClass('expanded');
        $('.browse-icons').addClass('expanded');
    });

    $('#sidebar').on('mouseleave', function (e) {
        if (!$('#sidebar').hasClass('expanded')) {
            $('.related-tabs').removeClass('expanded');
            $('.browse-icons').removeClass('expanded');
        }
    });

    $(".sidebar-toggle").click(function (e) {
        let $sidebar = $("#sidebar"),
            $body = $('.body-wrapper'),
            $sub_nav = $('.related-tabs'),
            $browse_icons = $('.browse-icons'),
            width = $(window).width(),
            show = $sidebar.hasClass('expanded') ? 0 : 1;

        $('.filter-sidebar').addClass('d-none');

        if (width <= 491) {
            $sidebar.toggleClass('expanded-mobile');
        } else {
            $sidebar.toggleClass('expanded');
            $sub_nav.toggleClass('expanded');
            $body.toggleClass('expanded');
            $browse_icons.toggleClass('expanded');
        }

        $.ajax({
            type: 'POST',
            url: '/sidebar/layout',
            data: {
                show
            }
        })
    });

    $(document).on('click', '#sidebar-user-trigger', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('#sidebar-user-dropdown .sidebar-user-menu').toggleClass('open');
    });

    $(document).on('click', function (e) {
        if (!$(e.target).closest('#sidebar-user-dropdown').length) {
            $('#sidebar-user-dropdown .sidebar-user-menu').removeClass('open');
        }
    });

    $(document).on('click', '#sidebar-user-dropdown .sidebar-user-menu .dropdown-item', function () {
        $('#sidebar-user-dropdown .sidebar-user-menu').removeClass('open');
    });

    $(".dashboard-sidebar-toggle").click(function (e) {
        let $dashboard_sidebar = $(".dashboard-sidebar"),
            $sidebar = $("#sidebar"),
            $body = $('.body-wrapper'),
            $sub_nav = $('.related-tabs'),
            $browse_icons = $('.browse-icons'),
            width = $(window).width(),
            show = $sidebar.hasClass('expanded') ? 0 : 1;

        $sidebar.removeClass('expanded');
        $sidebar.removeClass('expanded-mobile');
        $dashboard_sidebar.toggleClass('expanded');
        $body.removeClass('expanded');
    });

    $(document).on('click', '.open-customizer', function (e) {
        window.open($(this).attr('data-url'), '_blank').focus();
    });

    /////check if value is only number /////

    $(".decimal-check").on("change keyup input", function () {

        var position = this.selectionStart - 1;
        console.log('posotion', position);
        //remove all but number and .
        var fixed = this.value.replace(/[^0-9]/g, "");

        if (this.value !== fixed) {
            this.value = fixed;
            this.selectionStart = position;
            this.selectionEnd = position;

        }
    });

    //////////////////////////////////////

    /*$variable = $(".main-container").outerHeight() + 30;
    $('.page-container').css({'margin-top':$variable});*/

    ////trigger to save create page data/////
    $('#CreateSave').on('click', function (e, action) {
        if (action === 'save') {
            $('input[name="save_record_type"]').val('save_close');
            $('.floating-form.create-form #save').click();
            $('.floating-form.edit-form #save').click();
        } else {
            $('.save-edit').trigger('click', ['save_and_close']);
        }
    });

    $('.save-record-only').on('click', function (e, action) {
        if (action === 'save') {
            $('input[name="save_record_type"]').val('save_record_only');
            $('.floating-form.create-form #save').click();
            $('.floating-form.edit-form #save').click();
        } else {
            $('.save-edit').trigger('click', ['save_only']);
        }
    });

    $('.save-record-only-mobile').on('click', function (e, action) {
        $('.floating-form.create-form #save').click();
        $('.floating-form.edit-form #save').click();
    });

    $('#CreateSaveAndNew').on('click', function () {
        let $saveandnew = $('.floating-form #saveandnew').click();
    });

    ////////////////table edit blade checkbox value start////////////////////////////

    $('.chk_edit_tbl').change(function () {
        console.log('changed');
        if ($(this).is(":checked")) {
            $(this).val("true");
            console.log('true');
        } else {
            $(this).val("false");
            $(this).removeAttr("checked");
            console.log('false');
        }
    });

    ///////////////table edit blade checkbox value over////////////////////////////

    $('.button-container input').on('focus', function () {
        $(this).attr('autocomplete', 'off');
    });

    /////////////////date packer/////////////////////////

    //////////floating label/////////////////////////
    'use strict';
    // $(document).on('change', function () {
    //     $('.form-group .form-control').each(function () {
    //         $(this).floatingLabel('ChangeFortText');
    //     });
    // });
    //
    // $('.form-group .form-control').each(function () {
    //     $(this).floatingLabel('ChangeFortText');
    // });
    //
    // $(document).on('change', '.form-group .form-control', function () {
    //     $(this).floatingLabel('ChangeFortText');
    // });
    //
    // $(document).on('focusin', '.form-group .form-control', function () {
    //     $(this).floatingLabel('focusin');
    // });
    //
    // $(document).on('focusout', '.form-group .form-control', function () {
    //     $(this).floatingLabel('focusout');
    // });

});
(function ($) {
    'use strict';

    $.fn.floatingLabel = function (option) {
        var parent = $(this).closest('.form-group');

        if (parent.length) {
            switch (option) {
                case 'focusin':
                    $(this).closest('.form-group').addClass('control-focus');
                    break;
                case 'focusout':
                    $(this).closest('.form-group').removeClass('control-focus');
                    break;
                case 'ChangeFortText':
                    if (this.val()) {
                        parent.addClass('control-highlight');
                    } else {
                        parent.removeClass('control-highlight');
                    }
                    break;
                default:
                    $(this).closest('.form-group').addClass('control-highlight');
                    break;
            }
        }
        return this;
    };
}($));

// ________________ Color Picker Start _____________________
$(document).ready(function ($) {
    $('.nav_color').click(function () {
        $('.sidenav').css('width', '350px');
    });
    $('.closebtn').click(function () {
        $('.sidenav').css('width', '0');
    });

    $('.change_menu, .change_background, .change_table, .change_table_header, .change_button_color, .change_button_font_color, .change_btn_color, #table-header-color, #table-header-text-color').colorpicker({
        format: "hex",
        autoInputFallback: false,
        useAlpha: true
    });

    var menu_color;
    var background_color;
    var table_color;

    var menu_color = $("input[name=menu_color]").val();
    var background_color = $("input[name=background_color]").val();
    var table_color = $("input[name=table_color]").val();
    var button_color = $("input[name=change_button_color]").val();
    var button_font_color = $("input[name=change_button_font_color]").val();
    var table_header_color = $("input[name=table_header_color]").val();

    // Toggle the light-chrome classes on the navbar + sidebar so a light
    // menu colour switches text/icons to dark ink without a page reload.
    // Mirrors menuColorIsLight() in app/helpers.php (YIQ brightness > 150).
    function applyMenuColorTheme(color) {
        var str = String(color || '').trim(),
            r, g, b,
            rgb = str.match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);

        if (rgb) {
            r = +rgb[1]; g = +rgb[2]; b = +rgb[3];
        } else {
            var hex = str.replace('#', '');
            if (hex.length === 3) {
                hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
            }
            if (!/^[0-9a-f]{6}$/i.test(hex)) {
                return;
            }
            r = parseInt(hex.substr(0, 2), 16);
            g = parseInt(hex.substr(2, 2), 16);
            b = parseInt(hex.substr(4, 2), 16);
        }

        var isLight = ((r * 299) + (g * 587) + (b * 114)) / 1000 > 150;
        $('#sidebar').toggleClass('sidebar--light', isLight);
        $('.main-container').toggleClass('navbar--light', isLight);
    }

    applyMenuColorTheme(menu_color);

    $('.change_menu').on('colorpickerChange', function (event) {
        menu_color = event.color.toString();
        $('.change_menu_color').css('background-color', menu_color);
        $('#accent-bar-color').text(`tr.browse-detail-row > td::before, .browse-section-viewport-header::before, .browse-section-viewport-body::before { background-color: ${menu_color}; }`);
        applyMenuColorTheme(menu_color);
    });

    $('.change_background').on('colorpickerChange', function (event) {
        background_color = event.color.toString();
        $('.change_background_color').css('background-color', background_color);
    });

    $('.change_table').on('colorpickerChange', function (event) {
        table_color = event.color.toString();
        $('.change_table_color').css('background-color', table_color);
    });

    $('.change_table_header').on('colorpickerChange', function (event) {
        table_header_color = event.color.toString();
        $('.rel-sec-header').css('background-color', table_header_color);
    });

    $('.change_button_color').on('colorpickerChange', function (event) {
        button_color = $("input[name=change_button_color]").val();
        button_font_color = $("input[name=change_button_font_color]").val();
        $('.apply-btn-color').css("cssText", `background-color: ${button_color} !important; color: ${button_font_color} !important; border-color: ${button_font_color} !important`);
    });

    $('.change_button_font_color').on('colorpickerChange', function (event) {
        button_color = $("input[name=change_button_color]").val();
        button_font_color = $("input[name=change_button_font_color]").val();
        $('.apply-btn-color').css("cssText", `background-color: ${button_color} !important; color: ${button_font_color} !important; border-color: ${button_font_color} !important`);
    });

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    $(".submit_color").click(function (e) {
        var input_val;
        $(this).siblings('.color-outer').find('.colorpicker-element input').each(function () {
            input_val = $(this).val();
        });

        $('.apply-btn-color').removeClass('reset-btn-color');
        $("input[name=change_button_color]").trigger('colorpickerChange');
        $("input[name=change_button_font_color]").trigger('colorpickerChange');

        if (!input_val == '') {
            $.ajax({
                type: 'POST',
                url: '/store-color',
                dataType: 'json',
                data: {
                    menu_color: menu_color,
                    background_color: background_color,
                    table_color: table_color,
                    button_color,
                    button_font_color,
                    table_header_color
                },
                success: function (data) {
                    toastr.success('Setting saved')
                },
                error: function (error) {
                    console.log(error);
                }
            });
        } else {
            toastr.error('Please enter valid color');
        }
    });


    $(".reset_color").click(function () {
        $("input[name=menu_color]").val('#0162A7').trigger('change');
        $("input[name=background_color]").val('#f8fafc').trigger('change');
        $("input[name=table_color]").val('#ffffff').trigger('change');
        $("input[name=change_button_color]").val('#3490dc').trigger('change');
        $("input[name=change_button_font_color]").val('#FFFFFF').trigger('change');
        $("input[name=table_header_color]").val('#ebedf3').trigger('change');

        $('.change_menu_color').css('background-color', '#0162A7');
        applyMenuColorTheme('#0162A7');
        $('#accent-bar-color').text('tr.browse-detail-row > td::before, .browse-section-viewport-header::before, .browse-section-viewport-body::before { background-color: #0162A7; }');
        $('.change_background_color').css('background-color', '#f8fafc');
        $('.change_table_color').css('background-color', '#ffffff');
        $('.apply-btn-color').css('background-color', '').css('color', '').addClass('reset-btn-color');

        var menu_color = '#0162A7'
        var background_color = '#f8fafc';
        var table_color = '#ffffff';

        $.ajax({
            type: 'POST',
            url: '/store-color',
            dataType: 'json',
            data: {
                menu_color: menu_color,
                background_color: background_color,
                table_color: table_color,
                button_color: '',
                button_font_color: ''
            },
            success: function (data) {
                toastr.success('Setting Reset');
            },
            error: function (error) {
                console.log(error);
            }
        });
    });
});
// ________________ Color Picker End _____________________

// ________________ Menu Shorting Start __________________
$(document).ready(function ($) {
    $(".table_list").sortable({
        items: "tr",
        //cursor: 'grab',
        opacity: 0.6,
        forcePlaceholderSize: true,
        helper: function (e, tr) {
            var $originals = tr.children();
            var $helper = tr.clone();
            $helper.children().each(function (index) {
                // Set helper cell sizes to match the original sizes
                $(this).width($originals.eq(index).width());
            });
            return $helper;
        },

        update: function () {
            sendOrderToServer();
        }
    });

    function sendOrderToServer() {
        let order = [];
        $('.table_list tr').each(function (index, element) {

            order.push({
                id: $(this).attr('table-id'),
                position: index + 1
            });
        });

        $.ajax({
            type: "POST",
            dataType: "json",
            url: "/edit-order",
            data: {
                order: order
            },
            success: function (data) {
                toastr.success(data);
            },

            error: function (error) {
                console.log(error);
            }
        });
    }
});

$('.toggle-menu-show').on('change', function (e) {
    let show = $(this).is(':checked') ? 'true' : 'false',
        id = $(this).attr('data-menu-id');

    $.ajax({
        type: 'POST',
        url: '/menu/toggle',
        data: {
            id, show
        },
        success: function (res) {
            console.log(res);
        }
    })
});

// ________________ Menu Shorting End ____________________
// ____________ fontawesome iconpicker start _____________
$('.icp').iconpicker({
    templates: {
        buttons: '<button class="iconpicker-btn iconpicker-btn-cancel btn btn-default btn-sm">Cancel</button>' +
            ' <button class="iconpicker-btn iconpicker-btn-accept btn btn-primary btn-sm">Accept</button>',
    },
    icons: [
        {
            title: "fas fa-plus-circle",
            searchTerms: ['add', 'new record']
        }, {
            title: "fas fa-trash-alt",
            searchTerms: ['delete', 'remove', 'record']
        }, {
            title: "fas fa-file-download",
            searchTerms: ['download', 'file']
        }, {
            title: "fas fa-paper-plane",
            searchTerms: ['email', 'send']
        }, {
            title: "fas fa-cart-arrow-down",
            searchTerms: ['cart']
        }, {
            title: "fas fa-save",
            searchTerms: ['save']
        }, {
            title: "fas fa-window-close",
            searchTerms: ['window', 'close']
        }, {
            title: "fas fa-power-off",
            searchTerms: ['power off']
        }, {
            title: "fas fa-ambulance",
            searchTerms: ['ambulance']
        }, {
            title: "fas fa-universal-access",
            searchTerms: ['universal access']
        }, {
            title: "fas fa-share-alt-square",
            searchTerms: ['share']
        }, {
            title: "fas fa-globe-americas",
            searchTerms: ['globe', 'earth']
        }, {
            title: "fas fa-phone-square-alt",
            searchTerms: ['phone', 'call']
        }, {
            title: "fas fa-user-tie",
            searchTerms: ['user']
        }, {
            title: "fas fa-user-plus",
            searchTerms: ['user']
        }, {
            title: "fas fa-users",
            searchTerms: ['user']
        }, {
            title: "fas fa-tools",
            searchTerms: ['tools']
        }, {
            title: "fas fa-user-cog",
            searchTerms: ['user', 'settings']
        }, {
            title: "fas fa-info-circle",
            searchTerms: ['info', 'circle']
        }, {
            title: "fas fa-store",
            searchTerms: ['store']
        }, {
            title: "fas fa-laptop-house",
            searchTerms: ['laptop', 'house', 'work']
        }, {
            title: "fas fa-cloud-download-alt",
            searchTerms: ['cloud', 'download']
        }, {
            title: "fas fa-address-book",
            searchTerms: ['address book']
        }, {
            title: "fas fa-address-card",
            searchTerms: ['address card']
        }, {
            title: "fas fa-bell",
            searchTerms: ['bell']
        }, {
            title: "fas fa-book",
            searchTerms: ['book']
        }, {
            title: "fas fa-briefcase",
            searchTerms: ['briefcase']
        }, {
            title: "fas fa-bug",
            searchTerms: ['bug']
        }, {
            title: "fas fa-building",
            searchTerms: ['building']
        }, {
            title: "fas fa-chart-bar",
            searchTerms: ['chart bar']
        }, {
            title: "fas fa-chart-pie",
            searchTerms: ['chart pie']
        }, {
            title: "fas fa-chart-line",
            searchTerms: ['chart line']
        }, {
            title: "fas fa-copy",
            searchTerms: ['copy']
        }, {
            title: "fas fa-envelope",
            searchTerms: ['envelope']
        }, {
            title: "fas fa-edit",
            searchTerms: ['edit']
        }, {
            title: "fas fa-file-alt",
            searchTerms: ['file alt']
        }, {
            title: "fas fa-phone-volume",
            searchTerms: ['phone volume']
        }, {
            title: "fas fa-pen-nib",
            searchTerms: ['pen nib']
        }, {
            title: "fas fa-calendar-check",
            searchTerms: ['calendar check']
        }, {
            title: "fas fa-clipboard",
            searchTerms: ['clipboard']
        }, {
            title: "fas fa-tasks",
            searchTerms: ['tasks']
        }, {
            title: "fas fa-sitemap",
            searchTerms: ['sitemap']
        }, {
            title: "fas fa-table",
            searchTerms: ['table']
        }, {
            title: "fas fa-chalkboard-teacher",
            searchTerms: ['chalkboard teacher']
        }, {
            title: "fas fa-laptop-code",
            searchTerms: ['laptop code']
        }, {
            title: "fas fa-bell",
            searchTerms: ['bell']
        }, {
            title: "fas fa-paste",
            searchTerms: ['paste']
        }, {
            title: "fas fa-file-image",
            searchTerms: ['file image']
        }, {
            title: "fas fa-qrcode",
            searchTerms: ['qrcode', 'barcode']
        }, {
            title: "fas fa-map-marker-alt",
            searchTerms: ['location']
        }, {
            title: "fas fa-shipping-fast",
            searchTerms: ['truck', 'vehicle', 'delivery']
        }, {
            title: "fas fa-paperclip",
            searchTerms: ['paperclip', 'paper']
        }, {
            title: "fas fa-car",
            searchTerms: ['car', 'vehicle']
        }, {
            title: "fas fa-comment",
            searchTerms: ['comment', 'conversation']
        }, {
            title: "fas fa-trash",
            searchTerms: ['trash', 'delete']
        }, {
            title: "fas fa-money-bill",
            searchTerms: ['money', 'cash']
        }, {
            title: "fab fa-shopify",
            searchTerms: ['shopify']
        }, {
            title: "fas fa-handshake",
            searchTerms: ['handshake']
        }
    ],
});

$('.icp').on('iconpickerSelected', function (event) {
    let $remove_icon = $('.remove-icon-picker');
    $remove_icon.removeClass('d-none');
});

$('.icp').on('iconpickerSelected', function (event) {
    let $remove_icon = $('.remove-icon-picker'),
        $icon = $('.iconpicker-component');
    $remove_icon.removeClass('d-none');
    $icon.removeClass('d-none');
});

$('.remove-icon-picker').on('click', function (e) {
    $('.icon-name').val('');
    $('.iconpicker-component').addClass('d-none');
    $('.remove-icon-picker').addClass('d-none');
});


$(document).ready(function ($) {
    $(document).on('click', '.edit-menu-icon .iconpicker-item', function () {
        var icon_name = $(this).find('i').attr('class');
        $('.edit-menu-icon .icon-name').val(icon_name);
    });

    $(document).on('click', '.create_next', function () {
        if ($('.edit-menu-icon .icon-name').val() == 0) {
            $('.edit-menu-icon .icon-name').val('fas fa-building');
        }
    });
});
// ____________ fontawesome iconpicker end _____________

$('body').on('click', '.lock-table', function (e) {
    let id = $(this).attr('data-id'),
        is_default = $(this).data('default') === 1 ? 0 : 1;

    $(this).data('default', is_default);

    if (is_default) {
        $(this).removeClass('fa-unlock').addClass('fa-lock');
    } else {
        $(this).removeClass('fa-lock').addClass('fa-unlock');
    }

    $.ajax({
        type: 'POST',
        url: '/settings/tables/lock',
        data: {
            id,
            is_default: is_default
        },
        success: function (res) {
            toastr.success(translation.table_updated);
        }
    });
});

$(document).ready(function () {
    function triggerExperienceCalculation() {
        const yearsBefore = $('[name="years_before"]').val();
        const monthsBefore = $('[name="months_before"]').val();
        const daysBefore = $('[name="days_before"]').val();
        const startDate = $('[name="start_date"]').val();
        const endDate = $('[name="end_date"]').val();

        // Check all fields are filled
        if (
            yearsBefore === '' || monthsBefore === '' || daysBefore === '' ||
            startDate === ''
        ) {
            return; // Stop if any field is empty
        }

        const data = {
            years_before: parseInt(yearsBefore) || 0,
            months_before: parseInt(monthsBefore) || 0,
            days_before: parseInt(daysBefore) || 0,
            start_date: startDate,
            end_date: endDate,
            _token: '{{ csrf_token() }}'
        };

        $.ajax({
            url: '/calculate-experience',
            method: 'GET',
            data: data,
            success: function (response) {
                if(response){
                    $('[name="years_current"]').val(response.years_current);
                    $('[name="months_current"]').val(response.months_current);
                    $('[name="days_current"]').val(response.days_current);

                    $('[name="years_total"]').val(response.years_total);
                    $('[name="months_total"]').val(response.months_total);
                    $('[name="days_total"]').val(response.days_total);
                }
            },
            error: function (xhr) {
                console.error("Experience calculation error:", xhr.responseText);
            }
        });
    }

    if(window.tenant === 'cacao'){
        // Trigger when any relevant input changes
        $('[name="years_before"], [name="months_before"], [name="days_before"], [name="start_date"], [name="end_date"]')
            .on('keyup change', function () {
                triggerExperienceCalculation();
            });
    }

    $('.request-invite').on('click', function (e) {
        e.preventDefault();
        $('#request-modal').modal('show');
    });

    $('#send-request').on('click', function (e) {
        e.preventDefault();

        let email = $('#request-email').val(),
            name = $('#request-name').val(),
            message = $('#request-message').val();

        $('.request-error').empty();
        $.ajax({
            type: 'GET',
            url: '/request/invite',
            data: {
                email,
                name,
                message
            },
            success: function (res) {
                if (res) {
                    $('#request-modal').modal('hide');
                    $('#request-body').find('input').val('');
                    $('#request-body').find('textarea').val('');
                    bootbox.alert("Access requests has been sent!");
                }
            },
            error: function (res) {
                let errors = res.responseJSON.errors;
                for (let key in errors) {
                    if (errors.hasOwnProperty(key)) {
                        $(`.request-error[data-name="` + key + `"]`).text(errors[key]);
                    }
                }
                $('.login-loader').addClass('d-none');
            }
        });
    });
});